export default __webpack_public_path__ + "static/media/laptop_dark.bd6de7b8.png";